export const logError = (message, error, context = {}) => {
    const details = {
        message,
        context,
        errorMessage: error?.message || null,
        stack: error?.stack || null
    };

    // Basic structured logging that can be extended later.
    console.error('[app-error]', details);
};
